import { render, staticRenderFns } from "./LiveTradeDetails.vue?vue&type=template&id=3c9d3cd3&scoped=true"
import script from "./LiveTradeDetails.vue?vue&type=script&lang=js"
export * from "./LiveTradeDetails.vue?vue&type=script&lang=js"
import style0 from "./LiveTradeDetails.vue?vue&type=style&index=0&id=3c9d3cd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9d3cd3",
  null
  
)

export default component.exports